import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { allowedTagsRegex, clean } from './html-util';
var useStyles = makeStyles(function () { return ({
    wrapText: {
        whiteSpace: 'pre-line',
        wordBreak: 'break-all',
    },
}); });
/**
 * HTMLテキストを表示するコンポーネント
 * 改行をそのまま表示する。タグ不正、タグなしの場合はテーマを適用します
 */
export var HtmlText = function (props) {
    var classes = useStyles();
    var _a = React.useState(props.text), processedText = _a[0], setProcessedText = _a[1];
    React.useEffect(function () {
        // $coupon_urlが存在する場合現在のURLドメイン＋パスに置換する
        if (props.text.includes('$coupon_url')) {
            var url = window.location.origin + window.location.pathname;
            var encodedUrl = encodeURIComponent(url);
            var replacedText = props.text.replace(/\$coupon_url/g, encodedUrl);
            setProcessedText(replacedText);
        }
        else {
            setProcessedText(props.text);
        }
    }, [props.text]);
    // 許可されていないタグがあるか、タグがひとつもないとき
    if (!allowedTagsRegex.test(processedText)) {
        return (React.createElement(Typography, { className: classes.wrapText, variant: 'caption' }, processedText));
    }
    return (React.createElement("div", { style: { whiteSpace: 'pre-line', wordBreak: 'break-all' }, dangerouslySetInnerHTML: { __html: clean(processedText) } }));
};
//# sourceMappingURL=HtmlText.js.map